var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useGetRolesQuery } from '../../../../application/features/roles/role-api';
import { useUpdateUserStatusMutation } from '../../../../application/features/users/user-api';
import useTranslate from '../../../../localization/helpers';
var ActivateUserDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, user = _a.user;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var _c = useGetRolesQuery(false).data, roles = _c === void 0 ? [] : _c;
    var _d = __read(useUpdateUserStatusMutation(), 2), updateUserStatus = _d[0], _e = _d[1], updateUserStatusLoading = _e.isLoading, updateUserStatusSuccess = _e.isSuccess;
    var _f = useForm({
        reValidateMode: 'onChange',
        defaultValues: {
            roleId: undefined
        }
    }), control = _f.control, handleSubmit = _f.handleSubmit, errors = _f.formState.errors;
    var successMessage = useCallback(function () {
        enqueueSnackbar(tWithField('toolTips.activateSuccess', 'common.user'), {
            autoHideDuration: 3000,
            variant: 'success',
            anchorOrigin: { horizontal: 'right', vertical: 'top' }
        });
        onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose]);
    useEffect(function () {
        if (updateUserStatusSuccess)
            successMessage();
    }, [successMessage, updateUserStatusSuccess]);
    var onSubmit = function (request) {
        updateUserStatus(__assign(__assign({}, request), { isActive: true, userId: user.id }));
    };
    return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTitle, { id: 'confirm-dialog-title', children: tWithFunction('actions.activateFunction', 'common.user') }), _jsxs(DialogContent, { children: [_jsxs(DialogContentText, { id: 'confirm-dialog-description', children: [tWithFunction('users.statusConfirmText', 'common.activate'), !(user.role && user.isRoleActive) && " ".concat(translate('users.roleSelectionText'))] }), !(user.role && user.isRoleActive) && (_jsx(Box, { paddingTop: 2, children: _jsx(Controller, { name: 'roleId', control: control, rules: {
                                required: {
                                    value: true,
                                    message: tWithField('validations.fieldIsRequired', 'common.role')
                                }
                            }, render: function (_a) {
                                var _b;
                                var _c = _a.field, onChange = _c.onChange, value = _c.value, error = _a.fieldState.error;
                                return (_jsxs(FormControl, { fullWidth: true, variant: 'outlined', error: !!error, children: [_jsx(InputLabel, { children: translate('common.role') }), _jsx(Select, { value: value, onChange: onChange, label: translate('common.role'), disabled: updateUserStatusLoading, children: roles === null || roles === void 0 ? void 0 : roles.map(function (role) { return (_jsx(MenuItem, { value: role.id, disabled: !role.isActive, children: role.name }, role.id)); }) }), _jsx(FormHelperText, { children: (_b = errors.roleId) === null || _b === void 0 ? void 0 : _b.message })] }));
                            } }) }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: updateUserStatusLoading, variant: 'outlined', color: 'inherit', onClick: onClose, children: translate('actions.cancel') }), _jsx(Button, { disabled: updateUserStatusLoading, onClick: handleSubmit(onSubmit), variant: 'contained', color: 'warning', children: translate('actions.confirm') })] })] }));
};
export default ActivateUserDialog;
